import http from './http';
import socket from './socket';
import accessTokens from './access-tokens';
import users from './users';
import factories from './factories';
import factoryMemberships from './factory-memberships';
import sites from './sites';
import protocols from './protocols';
import labels from './labels';
import lines from './lines';
import devices from './devices';
import deviceMemberships from './device-memberships';
import deviceLabels from './device-labels';
import alarms from './alarms';
import attachments from './attachments';
import actions from './actions';
import commentActions from './comment-actions';
import notifications from './notifications';
import models from './models';
import channels from './channels';
import items from './items';
import alerts from './alerts';
import alertsSetting from './alerts-setting';
import reports from './reports';
import diagram from './diagram';
import dashboard from './dashboard';
import invoices from './invoices';
import settingPrices from './setting-prices';
import system from './system';
import architectures from './architectures';
import settingEmails from './setting-emails';

export { http, socket };

export default {
  ...accessTokens,
  ...users,
  ...factories,
  ...factoryMemberships,
  ...sites,
  ...protocols,
  ...labels,
  ...lines,
  ...devices,
  ...deviceMemberships,
  ...deviceLabels,
  ...alarms,
  ...attachments,
  ...actions,
  ...commentActions,
  ...notifications,
  ...models,
  ...channels,
  ...items,
  ...alerts,
  ...alertsSetting,
  ...reports,
  ...diagram,
  ...dashboard,
  ...invoices,
  ...settingPrices,
  ...system,
  ...architectures,
  ...settingEmails,
};
